export default {
    routerName: '履歴文章詳細',
    article: {
        title: 'タイトル',
        description: '記述',
        body: '詳細',
        author: '作者',
        status: '状態',
        status0: '下書き',
        status1: '審査失敗',
        status2: '審査中',
        status9: '審査成功',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        disabled: '無効',
        yes: 'はい',
        no: 'いいえ',
        hits: '閲覧量',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
        releaseTime: 'リリース日付',
    },
};
